export default function GetYearDate(time) {
    var date = new Date(time);
    var dd = date.getDate();
    var mm = date.getMonth()+1;
    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }
    var yy = date.getFullYear();

    var ddate = yy+"-"+mm+"-"+dd;
    return ddate.toString();
}